import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { RequestTokenService } from "../../../../../services/request-token.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

const API_URL = `${environment.apiUrl}v8/Notificacao`;

@Injectable({
  providedIn: 'root'
})
export class ApiNotificacaoService {

  constructor(
    private http: HttpClient,
    private requestToken: RequestTokenService
  ) { }

  private handleError(error: any): Observable<never> {
    return throwError(error);
  }

  public GetNotificacoes(): Observable<any> {
    const headers = this.requestToken.createAuthorizationHeader()
      .set('api-version', '1.0');

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetNotificacao`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public GetNotificacaoPendentes(): Observable<any> {
    const headers = this.requestToken.createAuthorizationHeader()
      .set('api-version', '1.0');

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetNotificacaoPendentes`, options)
      .pipe(
        catchError(this.handleError)
      );
  }

  public MarcarNotificacaoComoLida(notificacaoId: string): Observable<any> {
    const headers = this.requestToken.createAuthorizationHeader()
      .set('api-version', '1.0');

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/MarcarNotificacaoComoLida/${notificacaoId}`, options).pipe(
      catchError(this.handleError)
    );
  }

  public MarcarTodasNotificacoesComoLida(): Observable<any> {
    const headers = this.requestToken.createAuthorizationHeader()
      .set('api-version', '1.0');

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/MarcarTodasNotificacoesComoLida`, options).pipe(
      catchError(this.handleError)
    );
  }

  public CriarNotificacaoManutencao(signature: any): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/CriarNotificacaoManutencao`, signature, options)
      .pipe(catchError(this.handleError));
  }


}
